export default [
					{
						img:'./img/testimonios/DG.png',
						testimonio:"Trabajamos con la caja de plastomex porque tiene excelente calidad, es resistente para empacar y trasladar aguacate fresco a donde surtimos tanto mercados nacionales y de exportacion a canada, centroamerica, europa y asia.",
						autor:"Antonio Nuñez",
						puesto:"Gerente de Ventas"
					},
					{
						img:'./img/testimonios/PRODELEC.png',
						testimonio:"Con Plastomex mantenemos una excelente relación como cliente-proveedor en el suministro de material eléctrico, por ser una empresa confiable por más de 10 años.",
						autor:"Francisco Salvador Marquez",
						puesto:"Gerente Ventas, Sucursal Tecnológico"
					},
					{
						img:'./img/testimonios/PLASTOMEX.png',
						testimonio:"12 años formando parte de plastomex, me gusta mi trabajo, lo que hago y el ambiente. cuando descanso vengo a la planta con mas ganas de seguir trabajando.",
						autor:"J. Artemio Garcia Garcia",
						puesto:"Auxiliar De Inyeccion"
					}
				]